import SystemIcon from '../ShortStatus/SystemIcon';
import Button from '@material-ui/core/Button';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardFooter from '../../../components/Card/CardFooterTS';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import CloseIcon from '@material-ui/icons/Close';
import Lock from '@material-ui/icons/Lock';
import LockOpen from '@material-ui/icons/LockOpen';
import Ink from 'react-ink';
import React, { useState } from 'react';
import WiseneCardIcon from '../WiseneCardIcon/WiseneCardIcon.jsx';
import { cardTitle } from '../../../assets/jss/material-dashboard-pro-react-types';
import dashboardStyle from '../../../assets/jss/material-dashboard-pro-react/views/dashboardStyle';
import { CSSProperties } from '@material-ui/styles';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import { colorMap } from '../../helpers/GlobalVariables';
import RemoveSystemGroupConfirmationCard from '../RemoveSystemGroupConfirmationCard/RemoveSystemGroupConfirmationCard';
import '../ShortStatus/ShortStatusContent.css';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import ErrorText from '../ErrorComponent/ErrorText';

interface ISystemGroupShortStatusProps {
	systemGroup: any;
	linkDisabled: boolean;
	showSystemDocumentation?: boolean;
	mobileView: boolean;
	systemFiles: any;
	accountCategory: string;
}

const style = {
	cardTitle,
	cardCategory: dashboardStyle.cardCategory,
	stats: dashboardStyle.stats,
};

const deleteSystemStyle: CSSProperties = {
	width: '20px',
	height: '25px',
	minWidth: '25px',
	position: 'absolute',
	right: '5px',
	top: '5px',
	zIndex: 5,
};


const SystemGroupShortStatus = (props: ISystemGroupShortStatusProps) => {
	const { systemGroup, accountCategory } = props;
	const { ID, name, systemsCount, isPublic } = systemGroup;
	const [confirmationWindow, setConfirmationWindow] = useState(null);
	const cardIconStyle: CSSProperties = { cursor: 'pointer', position: 'relative' };
	const h3Style: CSSProperties = { ...cardTitle, minHeight: '70px' };
	const inkProps = {
		duration: 400,
		radius: 1250,
		inkStyle: { color: 'white' },
	};
    const iconColor = colorMap['none'];

	const lockIcon = isPublic ? <LockOpen/> : <Lock/>;

	const handleDelesteSystem = (e) => {
		e.preventDefault();
		showRemoveSystemConfirmation();
	};

	const hideRemoveSystemGroupConfirmation = () => {
		setConfirmationWindow(null);
	};

	const renderDeleteSystemButton = (): JSX.Element => {
		const showDeleteSystemIcon = ['wisene', 'installer'].includes(accountCategory);

		if (!showDeleteSystemIcon) {
			return null;
		}
		return (
			<Button className='deleteSystem' style={deleteSystemStyle} onClick={(e) => handleDelesteSystem(e)}>
				<CloseIcon className='deleteSystemIcon' style={{ color: '#dddddd', transition: '0.2s' }} />
			</Button>
		);
	};

	const showRemoveSystemConfirmation = (): void => {
		setConfirmationWindow(
			<SweetAlert
				title=''
				showConfirm={false}
				style={sweetAlertStyle}
				onConfirm={hideRemoveSystemGroupConfirmation}
				onCancel={hideRemoveSystemGroupConfirmation}
				key='remove-system-confirmation-alert'
			>
				<RemoveSystemGroupConfirmationCard systemGroup={systemGroup} hideRemoveSystemGroupConfirmation={hideRemoveSystemGroupConfirmation} />
			</SweetAlert>
		);
	};

	try {
		return (
			<ErrorComponent Children message='System group data cannot be showed.'>
				{confirmationWindow}
				<NavLink exact to={`/system-groups/${ID}/systems`} activeStyle={{ cursor: 'default' }}>
					<Card data-testid='systemGroupShortStatus'>
						{renderDeleteSystemButton()}
						<CardHeader color='info' icon>
							<WiseneCardIcon color={iconColor} style={cardIconStyle}>
								<SystemIcon />
								<Ink {...inkProps} />
							</WiseneCardIcon>
							<p style={style.cardCategory}>System group</p>
							<h3 style={h3Style}>{name}</h3>
						</CardHeader>
						<CardFooter>
						<p style={style.cardCategory}>{systemsCount} systems</p>
						<p style={style.cardCategory}>{lockIcon}</p>
						</CardFooter>
					</Card>
				</NavLink>
			</ErrorComponent>
		);
	} catch (error) {
		return <ErrorText message='System group data cannot be showed.' />;
	}
};

const mapStateToProps = (state) => {
	return {
		mobileView: state.dashboard.mobileView,
		accountCategory: state.login.accountCategory,
	};
};

export default connect(mapStateToProps)(SystemGroupShortStatus);
